import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('companies-index-lazy-load', class extends Controller {
  connect() {
    this.buttonIdx = 1
  }

  showClientList(e) {
    const button = e.currentTarget
    this.hideButton(button)
    this.showClientCards(button)
    this.showNextButton()
  }

  hideButton(button) {
    button.style.display = 'none'
  }

  showClientCards(button) {
    const nextClientCardsList = button.parentNode.getElementsByClassName('companies-index-splitted-company-card-list')[0]
    nextClientCardsList.classList.add('is-visible')
  }

  showNextButton() {
    this.buttonIdx++
    const nextButton = document.getElementById(`companies_index_button_id_${this.buttonIdx}`)

    if (nextButton === null) {
      return
    }

    nextButton.style.display = 'flex'
  }
})
